import { TrendingUp } from "lucide-react"

import { usePmbSection } from "~/hooks/pre-meeting"
import { type PmbSectionCtx } from "~/api/pre-meeting-v2"
import { type IndustryTrendsPayload } from "~/types/pre-meeting"

import { SectionShell } from "../section-ui"

// Presentational view: shared by the drawer and the ASKOS agent widget.
export function IndustryTrendsSectionView({
  payload,
  isLoading = false,
  error = null
}: {
  payload?: IndustryTrendsPayload | null
  isLoading?: boolean
  error?: string | null
}) {
  const trends = payload?.trends || []

  return (
    <SectionShell
      id="industry_trends"
      styleKey="industry_trends"
      icon={<TrendingUp size={16} />}
      title="Industry Trends"
      subtitle="Context to build credibility in the room"
      isLoading={isLoading}
      error={error}
      isEmpty={!trends.length}
      emptyText="No curated industry trends for this account yet."
    >
      <ul className="flex flex-col gap-3">
        {trends.map((tr, i) => (
          <li key={i} className="p-3 rounded-lg bg-[#059669]/5">
            <p className="text-[13px] font-semibold text-dark-2 dark:text-dark-6">
              {tr.headline}
            </p>
            <p className="text-[12px] text-gray-500 dark:text-text-gray-300 mt-0.5">
              {tr.implication}
            </p>
          </li>
        ))}
      </ul>
    </SectionShell>
  )
}

export function IndustryTrendsSection({
  ctx,
  enabled
}: {
  ctx: PmbSectionCtx
  enabled: boolean
}) {
  const { data, isLoading, isError } = usePmbSection<IndustryTrendsPayload>(
    "industry_trends",
    ctx,
    enabled
  )
  const error =
    data?.error || (isError ? "Could not load industry trends." : null)
  return (
    <IndustryTrendsSectionView
      payload={data?.payload}
      isLoading={isLoading}
      error={error}
    />
  )
}
